import React, { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import logo from "../../Components/Navbar/assets/logo.png";
import { getKeycloakPasswordResetUrl } from "../../config/keycloak";

export const RecoveryPassword: React.FC = () => {
  const { token } = useParams<{ token?: string }>();

  useEffect(() => {
    const redirectUri = `${window.location.origin}/login`;

    // If there's a token in the URL (from old system), redirect to Keycloak forgot password
    // Keycloak will handle its own token-based password reset flow
    const forgotPasswordUrl = getKeycloakPasswordResetUrl(redirectUri);

    // Redirect to Keycloak password reset page
    window.location.href = forgotPasswordUrl;
  }, [token]);

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#fdfdfd",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <img
        src={logo}
        alt="logo"
        style={{ width: "250px", height: "auto" }}
      />
      <CircularProgress size={50} />
      <Typography variant="h6" color="text.secondary">
        Redirecionando para recuperação de senha...
      </Typography>
    </Box>
  );
};
